import React, { useState } from 'react';
import EditJobDescription from './edit-job-description';
import PreviewJobDescription from './preview-job-description';
import PageHeaderText from 'components/base/page-header-text';
import { ROUTE_KEYS, ROUTE_PREFIX } from 'utils/constants';
import { Breadcrumbs } from '@cokitchen/cokitchen-components';
import useNewCareerPositionContext from 'contexts/career-position.context';

const JobDescription = () => {
  const { selectedJob } = useNewCareerPositionContext();
  const [editing, setEditing] = useState(false);

  const roleName = selectedJob?.role;
  const breadcrumbs = [
    { name: 'Overview', path: `${ROUTE_PREFIX.FOOD}/${ROUTE_KEYS.OVERVIEW}` },
    { name: 'Career', path: ROUTE_KEYS.CAREER },
    {
      name: `${roleName}`,
      path: ''
    }
  ];
  return (
    <div>
      <Breadcrumbs breadcrumbs={breadcrumbs} />
      <PageHeaderText
        title={roleName ?? 'Career'}
        description={`Update ${roleName ?? 'Career'} details here`}>
        {!editing && (
          <button
            className='border border-[#E7E8E9] shadow text-[#5C5F64] w-[86px] h-[40px] py-2 rounded-[8px]'
            onClick={() => {
              setEditing(true);
            }}>
            Edit
          </button>
        )}
      </PageHeaderText>
      {editing ? (
        <EditJobDescription onEditComplete={() => setEditing(false)} />
      ) : (
        <PreviewJobDescription />
      )}
    </div>
  );
};

export default JobDescription;
